import React, { useEffect, useState } from "react";
import { Popover, Whisper, Dropdown } from 'rsuite';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faVideo,
  faDesktop,
  faVideoSlash,
  faMicrophoneSlash,
  faDownload,
  faFilePdf,
  faFileCsv,
  faFileText,
  faSignOutAlt,
  faFileInvoice
  //faFileSignature
} from "@fortawesome/free-solid-svg-icons";
import "./MeetingFooter.css";
import { userIdForDB, userName, getRoomId } from "../../server/pyDbSpeaker";
import { connectionToPythonServerIsGiven, pythonDatachannel } from "../../server/peerConnection";

const MenuPopover = React.forwardRef(({ onSelect, ...rest }, ref) => (
  <Popover ref={ref} {...rest} full>
    <Dropdown.Menu onSelect={onSelect}>
      <Dropdown.Item eventKey={"protocol"}> <FontAwesomeIcon icon={faFilePdf} /> PDF-Transcript </Dropdown.Item>
      <Dropdown.Item eventKey={"table"}> <FontAwesomeIcon icon={faFileCsv} /> CSV-Transcript </Dropdown.Item>
      <Dropdown.Item eventKey={"summary"}> <FontAwesomeIcon icon={faFileText} /> Transcript-Summary </Dropdown.Item>
      <Dropdown.Item eventKey={"cards"}> <FontAwesomeIcon icon={faFileInvoice} /> Summary-Cards </Dropdown.Item>
    </Dropdown.Menu>
  </Popover>
));

const MeetingFooter = (props) => {
  const [streamState, setStreamState] = useState({
    mic: true,
    video: false,
    screen: false,
  });
  getState = streamState;

  const ref = React.useRef();
  function handleSelectMenu(eventKey, event) {
    onDownloadClick(eventKey);
    ref.current.close();
  }

  const micClick = () => {
    setStreamState((currentState) => {
      if(connectionToPythonServerIsGiven){
        pythonDatachannel.send(JSON.stringify({...currentState, mic: !currentState.mic}))
      }
      return {
        ...currentState,
        mic: !currentState.mic,
      };
    });
  };

  const onVideoClick = () => {
    setStreamState((currentState) => {
      if(connectionToPythonServerIsGiven){
        pythonDatachannel.send(JSON.stringify({...currentState, video: !currentState.video}))
      }
      return {
        ...currentState,
        video: !currentState.video,
      };
    });
  };

  const onScreenClick = () => {
    props.onScreenClick(setScreenState);
  };

  const setScreenState = (isEnabled) => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        screen: isEnabled,
      };
    });
  };

  const onDownloadClick = (typeOfProtocol) => {
    if(!typeOfProtocol){typeOfProtocol="protocol"}
    var roomID= getRoomId(); //pyDB.roomID
    var clientID = userIdForDB;
    var clientName = userName;
    var clientLanguage = navigator.language;
    if(!clientLanguage){clientLanguage = navigator.languages; if(clientLanguage){clientLanguage = clientLanguage.toString();}}
    var urlToProtocol= window.location.protocol + '//' + window.location.hostname + ':8060/'+typeOfProtocol+'?roomId='+roomID+'&userId='+clientID+'&userName='+clientName+'&language='+clientLanguage;
    window.open(urlToProtocol, "_blank", "noreferrer");
    //console.log("THIS LINK: ", urlToProtocol);
    //https://0.0.0.0:8060/protocol?roomId=Room-UUID&userId=User-UUID&userName=Paul
  }

  const onCloseCallClick = () => {
    var roomID= getRoomId(); //pyDB.roomID
    var typeOfProtocol = "logout";
    var clientID = userIdForDB;
    var clientName = userName;
    var clientLanguage = navigator.language;
    if(!clientLanguage){clientLanguage = navigator.languages; if(clientLanguage){clientLanguage = clientLanguage.toString();}}
    var urlToProtocol= window.location.protocol + '//' + window.location.hostname + ':8060/'+typeOfProtocol+'?roomId='+roomID+'&userId='+clientID+'&userName='+clientName+'&language='+clientLanguage;
    window.open(urlToProtocol, "_self");
  }
  
  
  useEffect(() => {
    props.onMicClick(streamState.mic);
  }, [streamState.mic]);// eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    props.onVideoClick(streamState.video);
  }, [streamState.video]);// eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="meeting-footer">
      <div
        className={"meeting-icons " + (!streamState.mic ? "active" : "")}
        data-tip={streamState.mic ? "Mute Audio" : "Unmute Audio"}
        onClick={micClick}
        title="Mikrofon An/Aus"
      >
        <FontAwesomeIcon
          icon={!streamState.mic ? faMicrophoneSlash : faMicrophone}
          title="Mute"
        />
      </div>
      <div
        className={"meeting-icons " + (!streamState.video ? "active" : "")}
        data-tip={streamState.video ? "Hide Video" : "Show Video"}
        onClick={onVideoClick}
        title="Kamera An/Aus"
        disabled={streamStateScreen}
      >
        <FontAwesomeIcon icon={!streamState.video ? faVideoSlash : faVideo} />
      </div>
      
      <div
        className={"meeting-icons " + (streamStateScreen ? "active" : "")}
        data-tip="Share Screen"
        onClick={onScreenClick}
        title="Bildschirm teilen"
        disabled={(getMobileOS()==="Android" || getMobileOS()==="iOS")}//? true : /*streamState.screen*/ streamStateScreen}
      >
        <FontAwesomeIcon icon={faDesktop} />
      </div>
      

      <div
        className={"meeting-icons downloadBg downloadIcon hidden"}
        data-tip="download"
        data-toggle="tooltip" 
        data-placement="top" 
        title="Download transcript"
        onClick={onDownloadClick}
        >
        <FontAwesomeIcon icon={faDownload} />
        
      </div>

      
        <Whisper
          placement="top"
          controlId="control-id-with-dropdown"
          trigger="click"
          ref={ref}
          speaker={<MenuPopover onSelect={handleSelectMenu} />}
        >
          <div
        className={"meeting-icons downloadBg downloadIcon "}
        data-tip="download"
        data-toggle="tooltip" 
        data-placement="top" 
        title="Download transcript"
        >
          <FontAwesomeIcon icon={faDownload} />
          </div>
        </Whisper>
        
        <div
        className={"meeting-icons closeBg closeIcon"}
        data-tip="close"
        title="Close Call"
        onClick={onCloseCallClick}
        >
        <FontAwesomeIcon icon={faSignOutAlt} />
        
      </div>
      
      
    </div>
  );
};

let streamStateScreen = false;
export let getState = {mic: true,video: false,screen: false};
export const screenSharedUpdated = (screenSharedState) =>{
  if(connectionToPythonServerIsGiven){
    pythonDatachannel.send(JSON.stringify({...getState, screen: screenSharedState}))
  }
  streamStateScreen = screenSharedState;
}

const getMobileOS = () => {
  const ua = navigator.userAgent
  if (/android/i.test(ua)) {
    return "Android"
  }
  else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)){
    return "iOS"
  }
  return "Other"
}

export default MeetingFooter;
